import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { Sparkles, Loader2 } from "lucide-react";
import ProductCard from "@/components/ProductCard";
import BackButton from "@/components/BackButton";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const NewProducts = () => {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchNewProducts = async () => {
      try {
        const response = await axios.get(`${API}/products/new/arrivals`);
        setProducts(response.data);
      } catch (error) {
        console.error("Error fetching new products:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchNewProducts();
  }, []);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center pt-20">
        <Loader2 className="h-8 w-8 animate-spin text-gray-400" />
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-white pt-20 pb-16" data-testid="new-products-page">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        {/* Back Button */}
        <div className="mb-4">
          <BackButton />
        </div>
        
        {/* Header */}
        <div className="mb-8">
          <div className="flex items-center gap-3 mb-2">
            <Sparkles className="h-6 w-6 text-yellow-500" />
            <h1 className="text-3xl font-bold">New Arrivals</h1>
          </div>
          <p className="text-gray-600">Our 40 newest product listings - oldest items drop off as new ones are added</p>
        </div>

        {/* Products Grid */}
        {products.length > 0 ? (
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-6">
            {products.map((product) => (
              <ProductCard key={product.id} product={product} />
            ))}
          </div>
        ) : (
          <div className="text-center py-16">
            <Sparkles className="h-12 w-12 text-gray-300 mx-auto mb-4" />
            <h3 className="text-lg font-medium text-gray-600 mb-2">No new products yet</h3>
            <p className="text-gray-500 mb-4">Check back soon for new arrivals!</p>
            <Link 
              to="/products" 
              className="inline-flex items-center px-4 py-2 bg-black text-white rounded-full hover:bg-gray-800 transition-colors"
            >
              Browse All Products
            </Link>
          </div>
        )}
      </div>
    </div>
  );
};

export default NewProducts;
